var _mask, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIdentifyUnchecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_45_66",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28V26.4C7.15167 26.4 1.6 20.8483 1.6 14H0H-1.6C-1.6 22.6156 5.38436 29.6 14 29.6V28ZM28 14H26.4C26.4 20.8483 20.8483 26.4 14 26.4V28V29.6C22.6156 29.6 29.6 22.6156 29.6 14H28ZM14 0V1.6C20.8483 1.6 26.4 7.15167 26.4 14H28H29.6C29.6 5.38436 22.6156 -1.6 14 -1.6V0ZM14 0V-1.6C5.38436 -1.6 -1.6 5.38436 -1.6 14H0H1.6C1.6 7.15167 7.15167 1.6 14 1.6V0Z",
    fill: "#00C950",
    mask: "url(#path-1-inside-1_45_66)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3334 10L12 17.3333L8.66669 14",
    stroke: "#00C950",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIdentifyUnchecked);
export default __webpack_public_path__ + "static/media/ic_identify_unchecked.745d68be8cb2fa9db81e1d779c70be93.svg";
export { ForwardRef as ReactComponent };